import React from "react"
import styled from "styled-components"
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus"
import { AiOutlineDelete } from "@react-icons/all-files/ai/AiOutlineDelete"
import { useSelector, useDispatch } from "react-redux"
import { getTopic, getNotes } from "../../utils/cart"
import { useAddUserPutMutation, useGetUserQuery } from "./features/api/authApi"
import { addNotes } from "./features/authSlice"

function Notes(props) {
  const {
    data,
    elapsedTime,
    curriculumIndex,
    subtopicIndex,
    progress,
    player,
    keyId,
  } = props
  const [text, setText] = React.useState("")
  const [show, setShow] = React.useState(true)
  const [seconds, setSeconds] = React.useState(0)

  const token = useSelector((state) => state.token)
  const topic = getTopic()
  const notes = getNotes()
  const { data: userProfile, isError } = useGetUserQuery()
  const [addUserPut, { isLoading, isSuccess, status }] = useAddUserPutMutation()

  console.log("isLoading", isLoading);
  console.log("isSuccess", isSuccess);
  console.log("status", status);
  const dispatch = useDispatch()
  //   const { token, notes, addNotes, user, userProfile, topic } =
  //     React.useContext(UserContext)

  React.useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(player?.current?.getCurrentTime())
    }, 1000)
    return () => clearInterval(interval)
  }, [player])

  const moduleId =
    typeof topic[keyId] !== "undefined" ? topic[keyId]?.module_ids : 0
  const sectionId =
    typeof topic[keyId] !== "undefined" ? topic[keyId]?.section_id : 0
  const insideSectionId =
    typeof topic[keyId] !== "undefined" ? topic[keyId]?.insideSection_id : 0

  const childSectionId =
    data.modules[moduleId]?.course_sections[sectionId]?.sections[
      insideSectionId
    ]?.id

  const parentSectionId = data.modules[moduleId]?.course_sections[sectionId]?.id

  const handleSave = async (currentTime1) => {
    try {
      const copy = [...notes]
      const index = copy?.findIndex(
        (al) => al.parentSection === parentSectionId
      )
      if (index === -1) {
        copy?.push({
          parentSection: parentSectionId,
          id: data.id,
          subtopicNotes: [
            {
              notes: [{ note: text, time: currentTime1 }],
              childSection: childSectionId,
            },
          ],
        })
      } else {
        const index1 = copy[index].subtopicNotes.findIndex(
          (st) => st.childSection === childSectionId
        )
        {
          index1 === -1
            ? copy[index]?.subtopicNotes.push({
                notes: [{ note: text, time: currentTime1 }],
                childSection: childSectionId,
              })
            : copy[index]?.subtopicNotes[index1].notes.push({
                note: text,
                time: currentTime1,
              })
        }
      }

      const credentials = { userNotes: copy }
      const kId = userProfile[0].id
      dispatch(addNotes({ copy }))
      await addUserPut({ credentials, kId })
      isSuccess && props.onPlayPause()
    } catch (err) {
      console.log(err)
    }
  }

  const handleDeleteNotes = async (idTopic, idCurriculum, noteText) => {
    const copy = [...notes]
    try {
      const getId = copy?.findIndex((n) => n.parentSection === idCurriculum)
      const getTopicId = copy[getId]?.subtopicNotes?.findIndex(
        (st) => st.childSection === idTopic
      )
      const getNotesId = copy[getId]?.subtopicNotes[
        getTopicId
      ]?.notes?.findIndex((nt) => nt.note === noteText)

      copy[getId]?.subtopicNotes[getTopicId]?.notes.splice(getNotesId, 1)

      const credentials = { userNotes: copy }
      const kId = userProfile[0].id
      dispatch(addNotes({ copy }))
      await addUserPut({ credentials, kId })
    } catch (err) {}
  }

  const handleSeek = (time) => {
    player.current.seekTo(time)
  }
  const format = (seconds) => {
    if (isNaN(seconds)) {
      return "00:00"
    }
    const date = new Date(seconds * 1000)
    const hh = date.getUTCHours()

    const mm = date.getUTCMinutes()
    const ss = date.getUTCSeconds().toString().padStart(2, "0")

    if (hh) {
      return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`
    }

    return `${mm}:${ss}`
  }

  console.log(player.current)
  return (
    <Wrapper>
      <div className="box_layout">
        {props.showNotes ? (
          <>
            <div className="bookmark_notes">
              <div className="elapsed_time">
                {format(player?.current?.getCurrentTime())}
              </div>

              <div className="box_writing_notes">
                <textarea
                  id="notesSave"
                  name="notes"
                  value={text}
                  rows="4"
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
            </div>
            <div className="button_save">
              <button
                className="save"
                onClick={() => handleSave(player?.current?.getCurrentTime())}
              >
                {!isLoading ? "save" : "loading..."}
              </button>
              <button className="cancel" onClick={props.onPlayPause}>
                cancel
              </button>
            </div>
          </>
        ) : (
          <div className="notes_list">
            <div className="video_timer" onClick={props.onPlayPause}>
              <h2>Create a new Note</h2>
              <AiOutlinePlus />
            </div>
            <div className="list_of_notes">
              {notes &&
                notes?.map(
                  (n) =>
                    n.id === data.id &&
                    n.subtopicNotes.map(
                      (st) =>
                        st.childSection === childSectionId &&
                        st.notes.map((nt) => {
                          return (
                            <div className="lists_of_lists">
                              <div className="notes_p">
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSeek(nt.time)}
                                >
                                  {format(nt.time)}
                                </span>
                                <p>{nt.note}</p>
                              </div>
                              <button
                                style={{
                                  background: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <AiOutlineDelete
                                  onClick={() =>
                                    handleDeleteNotes(
                                      st.childSection,
                                      n.parentSection,
                                      nt.note
                                    )
                                  }
                                  className="notes_delete"
                                />
                              </button>
                            </div>
                          )
                        })
                    )
                )}
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  )
}

export default Notes

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  align-items: center;
  display: flex;
  justify-content: center;
  .box_layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
  }
  .video_timer {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    width: 80%;
    align-items: center;
    padding: 19px;
    background: #f8f8f8;
    @media (max-width: 767px) {
      width: 100%;
    }
    h2 {
      @media (max-width: 767px) {
        font-size: 1rem;
      }
    }
  }
  .bookmark_notes {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .elapsed_time {
    width: 10%;
    margin-right: 15px;
  }
  .notes_list {
    display: flex;
    width: 100%;
    flex-direction: column;
    .list_of_notes {
      display: flex;
      flex-direction: column;
      width: 80%;
      margin-top: 30px;
      height: 400px;
      overflow-y: auto;
      @media (max-width: 767px) {
        width: 100%;
      }
      .notes_delete {
        font-size: 22px;
        color: #000;
        @media (max-width: 479px) {
          font-size: 18px;
        }
      }
      .lists_of_lists {
        display: flex;
        align-items: center;
        margin: 10px;
        justify-content: space-between;
        .notes_p {
          display: flex;
          align-items: center;
        }
        span {
          background-color: #f8f8f8;
          border-radius: 10px;
          padding: 10px;
          margin-right: 10px;
          min-width: 70px;
          display: flex;
          justify-content: center;
          @media (max-width: 767px) {
            font-size: 14px;
            min-width: 50px;
          }
        }
        p {
          margin: 0;
          margin-right: 50px;
          @media (max-width: 479px) {
            font-size: 13px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .box_writing_notes {
    width: 80%;
    @media (max-width: 767px) {
      width: 90%;
    }
    textarea {
      width: 100%;
      resize: none;
    }
  }
  .button_save {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    .save,
    .cancel {
      padding: 15px 20px;
      background: var(--thirdColor);
      color: var(--secondaryColor);
      font-weight: 500;
      font-size: 16px;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      min-width: 150px;
      @media (max-width: 767px) {
        padding: 11px 20px;
        font-size: 14px;
        min-width: 100px;
      }
    }
    .cancel {
      margin-left: 10px;
      background: none;
      border: 1px solid var(--thirdColor);
    }
  }
`
